import React from "react";

export default function PhoneFrame({ children }) {
  return (
    <div className="impo-shell" data-testid="impo-shell">
      <div className="impo-phone" data-testid="impo-phone">{children}</div>
    </div>
  );
}
